import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { typeProduct, typeProductType } from '../../types/slices/typeProductType'

const initialState: typeProductType =
{
    status: ApiStatus.FETCHED,
    typeProducts: [],
    typeProductSelected: {} as typeProduct,
    errorMessage: undefined,
    action: ''
}

const typeProductSlice = createSlice({
    name: 'typeProductSlice',
    initialState,
    reducers: {
        onFetchTypeProducts (state, { payload }: { payload: typeProduct[]}) {
            state.status = ApiStatus.FETCHED
            state.typeProducts = payload
            state.errorMessage = undefined
        },
        onSetSelectedTypeProduct (state, { payload }: { payload: typeProduct }) {
            state.typeProductSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectTypeProductState = (state: RootState) => state.typeProductSlice
export default typeProductSlice.reducer
export const {
    onFetchTypeProducts,
    onSetSelectedTypeProduct,
    changeStatus,
    setAction,
} = typeProductSlice.actions
